import { Suspense } from "react";

import { Outlet } from "react-router-dom";

import { RVLoading } from "../../atoms";

import styles from "./RVRoutingPage.module.scss";

export type RVRoutingPageProps = {
    /** Optional navigation content rendered to the left of the page content. */
    nav?: React.ReactNode;
};

/**
 * Full-page route-driven layout shell.
 *
 * Wraps React Router `Outlet` with an optional navigation slot and a `Suspense`
 * boundary. Child routes are rendered by the `Outlet`.
 *
 * @example
 * ```tsx
 * <RVRoutingPage nav={<SidebarNav />} />
 * ```
 */
export function RVRoutingPage({ nav }: RVRoutingPageProps): JSX.Element {
    return (
        <div className={styles.fullPage}>
            {nav}
            <Suspense fallback={<RVLoading />}>
                <Outlet />
            </Suspense>
        </div>
    );
}
